import { type AppState } from '../../common/types';

export const getReadingSessionId = (state: AppState) => state.readingSessionId;
